import { gql } from "apollo-boost";

export const Stats = gql`
  {
    stats {
      a
    }
  }
`;
